import React, { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { SocietyWebsiteQuestionsAndAnswersSection } from './SocietyWebsiteQuestionsAndAnswersSection'
import { useToastNotifications } from '../../../../hooks/useToastNotification'
import { ToastType } from '../../../common/Toast/toast-type'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { Toggle } from '../../../common/Toggle'
import { patchWebsite } from '../../../../api/society-websites'
import { ISocietyWebsiteModel } from '../../../../interfaces/models/societies-websites.interfaces'

interface SocietyWebsiteQuestionsAndAnswersProps {
  website: ISocietyWebsiteModel
}

export const SocietyWebsiteQuestionsAndAnswers = ({
  website,
}: SocietyWebsiteQuestionsAndAnswersProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const [show, setShow] = useState<boolean>(!!website.brokerQuestion?.show)
  const { setToastNotification } = useToastNotifications()
  const sections = website.brokerQuestion?.sections?.map((_section) => ({
    ..._section,
  }))

  const { mutate: mutatePatchWebsite } = useMutation({
    mutationFn: patchWebsite,
    onSuccess: () => {
      setToastNotification(
        ToastType.SUCCESS,
        translate(
          'societyWebsiteQuestionsAndAnswers.flashMessage.updateSuccess'
        )
      )
    },
    onError: () => {
      setToastNotification(
        ToastType.DANGER,
        translate(
          'societyWebsiteQuestionsAndAnswers.flashMessage.updateSuccess'
        )
      )
    },
  })

  const onShowChange = async (value: boolean): Promise<void> => {
    setShow(value)
    mutatePatchWebsite({
      id: website._id,
      body: {
        brokerQuestion: {
          ...website.brokerQuestion,
          show: value,
        },
      },
    })
  }

  return (
    <div className="w-full space-y-6">
      <Toggle
        label={translate('societyWebsite.showOnWebsite')}
        wrapperClassName="w-fit"
        name="societyWebsiteFAQShow"
        enabled={show}
        onChange={onShowChange}
      />
      {sections?.map((item) => (
        <SocietyWebsiteQuestionsAndAnswersSection
          key={item._id}
          id={item._id}
          title={item.title || ''}
          website={website}
        />
      ))}
    </div>
  )
}
